// Visitors on the Hosting site's default domains are sent to the platform's
// public address (lib/platformUrl), same path, query and hash — so the Firebase
// auth domain (my.wannablab.com in production) is always first-party and an
// old email sign-in link (…web.app/login/finish?mode=signIn&oobCode=…) arrives
// on the canonical domain intact. main.jsx runs this before the app (and
// Firebase) loads, in production builds only.
//
// Only these hosts redirect: localhost, `vite preview`, preview channels
// (my-wannablab--<channel>-<hash>.web.app) and the canonical domain itself
// never do.
export const ALIAS_HOSTS = ['my-wannablab.web.app', 'my-wannablab.firebaseapp.com'];

/** The URL to move to, or null to stay. */
export const canonicalRedirectUrl = ({ href, canonical }) => {
    let current;
    let target;
    try {
        current = new URL(href);
        target = new URL(canonical);
    } catch {
        return null;
    }
    if (!ALIAS_HOSTS.includes(current.hostname) || current.host === target.host) return null;
    return `${target.origin}${current.pathname}${current.search}${current.hash}`;
};
